export interface UpdateLimit {
  sectionNumber: number;
  totalRepairLimits: UpdateTotalRepairLimits;
  otherRepairLimits: UpdateOtherRepairLimits;
}

export interface UpdateTotalRepairLimits {
  totalRepairs: number;
  nailRepairs: number;
  rnailCrownRepairs: number;
  rnailShoulder: UpdateRNailShoulder;
  section: UpdateSection;
}

interface UpdateRNailShoulder {
  repairs: number;
  shoulder: RepairCountSize;
  crown?: RepairCountSize;
}

export interface RepairCountSize {
  count: number;
  size: string;
}

interface UpdateSection extends UpdateRNailShoulder {
  sidewall: RepairCountSize;
}

export interface UpdateOtherRepairLimits {
  spot: number;
  bead: number;
  liner: number;
  brake: number;
}

export enum ReparLimitSizes {
  SR33 = 'SR33',
  SR35 = 'SR35',
  SR37 = 'SR37',
  SR40 = 'SR40',
  SR42 = 'SR42',
  SR44 = 'SR44',
  RSR22 = 'RSR22',
  RSR24 = 'RSR24',
  RSR26 = 'RSR26'
}
